(function () {
  'use strict';

  var promos = document.querySelectorAll('[data-makeen-promo]');
  if (!promos.length) return;

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function updatePromoHeight(promo) {
    var height = promo.hidden ? 0 : Math.ceil(promo.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--makeen-promo-height', height + 'px');
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();

      try {
        document.execCommand('copy') ? resolve() : reject(new Error('copy failed'));
      } catch (error) {
        reject(error);
      }

      document.body.removeChild(field);
    });
  }

  promos.forEach(function (promo) {
    var dataset = promo.dataset;
    var code = dataset.code || '';
    var mode = dataset.timerMode || 'recurring';
    var durationHours = Math.max(1, Number(dataset.durationHours) || 24);
    var expiredBehavior = dataset.expiredBehavior || 'restart';
    var campaignKey = [code, mode, durationHours, dataset.fixedEnd || ''].join(':');
    var deadlineKey = 'makeenPromoDeadline:' + campaignKey;
    var dismissKey = 'makeenPromoDismissed:' + campaignKey;
    var timer = promo.querySelector('[data-promo-timer]');
    var status = promo.querySelector('[data-promo-status]');
    var close = promo.querySelector('[data-promo-close]');
    var copy = promo.querySelector('[data-promo-copy]');
    var intervalId;
    var lastAnnouncedMinute = null;

    if (!window.Shopify || !window.Shopify.designMode) {
      if (dataset.dismissible === 'true' && readStorage(dismissKey) === 'true') {
        promo.hidden = true;
      }
    }

    updatePromoHeight(promo);

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        updatePromoHeight(promo);
      }).observe(promo);
    } else {
      window.addEventListener('resize', function () {
        updatePromoHeight(promo);
      });
    }

    if (close) {
      close.addEventListener('click', function () {
        promo.hidden = true;
        writeStorage(dismissKey, 'true');
        updatePromoHeight(promo);
      });
    }

    if (copy) {
      copy.addEventListener('click', function () {
        copyText(code).then(function () {
          copy.classList.add('is-copied');
          if (status) status.textContent = 'Promocode ' + code + ' wurde kopiert.';
          window.setTimeout(function () {
            copy.classList.remove('is-copied');
          }, 1800);
        });
      });
    }

    if (!timer || dataset.timerEnabled !== 'true') return;

    var daysGroup = timer.querySelector('[data-days-group]');
    var daysSeparator = timer.querySelector('[data-days-separator]');
    var daysNode = timer.querySelector('[data-days]');
    var hoursNode = timer.querySelector('[data-hours]');
    var minutesNode = timer.querySelector('[data-minutes]');
    var secondsNode = timer.querySelector('[data-seconds]');

    function recurringDeadline() {
      var stored = Number(readStorage(deadlineKey));
      if (Number.isFinite(stored) && stored > 0) return stored;
      var next = Date.now() + durationHours * 60 * 60 * 1000;
      writeStorage(deadlineKey, String(next));
      return next;
    }

    var deadline = mode === 'fixed' ? Date.parse(dataset.fixedEnd) : recurringDeadline();

    function expire() {
      if (mode === 'recurring' && expiredBehavior === 'restart') {
        deadline = Date.now() + durationHours * 60 * 60 * 1000;
        writeStorage(deadlineKey, String(deadline));
        tick();
        return;
      }

      window.clearInterval(intervalId);

      if (expiredBehavior === 'hide') {
        promo.hidden = true;
        updatePromoHeight(promo);
        return;
      }

      timer.innerHTML = '<span class="makeen-promo__expired"></span>';
      timer.querySelector('.makeen-promo__expired').textContent = dataset.expiredText || 'Aktion beendet';
      if (status) status.textContent = dataset.expiredText || 'Aktion beendet';
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function tick() {
      if (!Number.isFinite(deadline)) {
        expire();
        return;
      }

      var remaining = Math.max(0, deadline - Date.now());
      if (remaining <= 0) {
        expire();
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      var showDays = days > 0;

      daysGroup.hidden = !showDays;
      daysSeparator.hidden = !showDays;
      daysNode.textContent = pad(days);
      hoursNode.textContent = pad(hours);
      minutesNode.textContent = pad(minutes);
      secondsNode.textContent = pad(seconds);

      var announcedMinute = Math.ceil(remaining / 60000);
      if (status && announcedMinute !== lastAnnouncedMinute) {
        lastAnnouncedMinute = announcedMinute;
        var dayText = days ? days + (days === 1 ? ' Tag, ' : ' Tagen, ') : '';
        status.textContent = 'Das Angebot endet in ' + dayText + hours + ' Stunden und ' + minutes + ' Minuten.';
      }
    }

    tick();
    intervalId = window.setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });
  });
})();
